const PartnerIndex = () => import("@/views/companiesAndTerritories/partners/PartnerIndex.vue")
const PartnerTerritoryIndex = () => import("@/views/companiesAndTerritories/partners/PartnersTerritoryIndex.vue")
const PartnerHoldingIndex = () => import("@/views/companiesAndTerritories/partners/PartnersHoldingIndex.vue")
const AddBulkSites = () => import("@/views/companiesAndTerritories/AddBulkSites.vue")

const moduleBasePath = "/admin/partners/"
const routes = [
    {
        path: `${moduleBasePath}`,
        name: "partnersIndex",
        component: PartnerIndex,
        meta: {
            label: "Partners"
        },
        children: [
            {
                path: "territory/:id?",
                component: PartnerTerritoryIndex,
                name: "partnerTerritoryIndex"
            },
            {
                path: "holding/:id?/:affiliateId?",
                component: PartnerHoldingIndex,
                name: "partnerHoldingIndex"
            }
        ]
    },
    {
        path: "/admin/add-bulk-sites",
        name: "addBulkSites",
        component: AddBulkSites,
        meta: {
            label: "Add bulk sites"
        }
    }
]

export default routes
